import React, { useEffect } from 'react'
import newsletter from "./images/newsletter_img.png"
import newslettershape1 from './images/newsletter_shape01.png'
import newslettershape2 from './images/newsletter_shape02.png'
import { Link } from 'react-router-dom'
import AOS from 'aos';
import 'aos/dist/aos.css';


const HomeSubscribe = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='Home_subscribe_section' data-aos="flip-right" data-aos-duration="2000">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='Home_subscribe_section_img1'>
                            <img src={newsletter} className=' img-fluid' />
                        </div>

                        <div className='Home_subscribe_section_img3'>
                            <img src={newslettershape2} className=' img-fluid' />
                        </div>
                    </div>
                    <div className='col-lg-8 m-auto Home_subscribe_section_content' >
                        <h1>Do you want to be updated on new studies and courses?</h1>
                        <div>
                            <input type='text' className='form-control' placeholder='Type Your E-Mail' />
                        </div>
                        <div className='text-center'>
                            <Link to="/contact-us"><button>Subscribe now <span><i class="ri-arrow-right-line"></i></span></button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeSubscribe
